<div class="row g-3 align-items-end">
  <div [class]="colImage" *ngIf="event.image">
    <img [src]="event.image" (error)="onImageError($event)" class="img-fluid rounded" alt="..." />
  </div>

  <div class="col">
    <div class="d-flex gap-2">
      <span class="badge badge-soft-primary" *ngIf="event.entityName === 'UserEvent'">
        Custom Event
      </span>
      <span class="badge badge-soft-cyan" *ngIf="event.myEventInd"> My Event </span>
      <span class="badge badge-soft-primary" *ngIf="event.rsvpLimit">
        RSVP
        <ng-container *ngIf="event.rsvpLimit === event.rsvpListCount"> - Closed</ng-container>
      </span>
    </div>

    <h5 class="fw-bolder m-0 mt-2">{{ event.eventName || event.title }}</h5>
    <div class="row g-3">
      <div
        class="col-auto"
        [ngClass]="{
          'border-end': event.locationName || event.communityLocationName,
        }"
      >
        {{ mm.utc(event.startsAt).format('hh:mm a') }}
      </div>
      <div class="col-auto" *ngIf="event.locationName || event.communityLocationName">
        {{ event.locationName || event.communityLocationName }}
      </div>
    </div>

    <div class="row" *ngIf="event.rsvpDeadlineDt">
      <div class="col-12">
        <b>RSVP By: </b> {{ mm.utc(event.rsvpDeadlineDt).format('MMM DD, YYYY') }}
      </div>
    </div>
  </div>
  <div class="col-12">
    <p [ngClass]="{'paragraph-truncate lines-3':truncate}" class="col m-0" [innerHTML]="event.eventDescription">
    </p>
  </div>
</div>

<div class="row align-items-center mt-3 g-2">
  <div class="col">
    <!-- <p>
      attendanceInd
      {{ event.attendanceInd }}
    </p>
-->
    <ng-container *ngIf="role === 'COMMUNITY_RESIDENT'; else family">
      <button
        (click)="onAttend(event)"
        class="btn btn-light w-100"
        *ngIf="!event.attendanceInd && !event.rsvpLimit"
      >
        Attend
      </button>

      <button
        (click)="onUnAttend(event)"
        class="btn btn-success w-100"
        *ngIf="(event.attendanceInd || event.inRsvpListInd) && !event.myEventInd"
      >
        Attending
      </button>

      <button
        (click)="onRsvp(event)"
        class="btn btn-light w-100"
        *ngIf="event.rsvpLimit && !event.inRsvpListInd && event.rsvpLimit > event.rsvpListCount"
      >
        RSVP
      </button>

      <button
        (click)="onWaitlist(event)"
        class="btn btn-light w-100"
        *ngIf="
          event.rsvpLimit &&
          !event.inRsvpListInd &&
          event.rsvpLimit === event.rsvpListCount &&
          event.waitListEnabledInd &&
          !event.inWaitListInd
        "
      >
        Join Waitlist
      </button>

      <button (click)="onUnWaitlist(event)" class="btn btn-info w-100" *ngIf="event.inWaitListInd">
        On Waitlist
      </button>

      <button (click)="onManage(event)" class="btn btn-soft-cyan w-100" *ngIf="event.myEventInd">
        Manage Event
      </button>
    </ng-container>
    <ng-template #family>
      <button
        class="btn btn-success w-100"
        *ngIf="(event.attendanceInd || event.inRsvpListInd) && !event.myEventInd"
      >
        Loved One Attending
      </button>
    </ng-template>
  </div>
  <div class="col-auto" *ngIf="details">
    <a class="text-icon float-end" href="javascript: void(0);" (click)="onDetails(event)">
      See details
      <i class="bx bx-chevron-right"></i>
    </a>
  </div>
</div>
